<template>
  <div class="home">
    <div class="message">
      <div class="message-title">好兽药{{chatRoomId}}聊天室</div>
      <div class="message-list">
        <!-- <cube-scroll id="aa" ref="scroll" :data="speak"> -->
          <div v-for="(item,i) in speak" :key="i">
            <div class="message-left" v-if="item.user.name !== cuName">
              <div class="message-img"><img :src="item.user.portrait"></div>
              <div class="message-info">
                <div class="message-info-name">{{item.user.name}}</div>
                <div class="message-info-text">{{item.content | expression}}</div>
              </div>
            </div>
            <div class="message-right" v-else>
              <div class="message-info">
                <div class="message-info-name">{{item.user.name}}</div>
                <div class="message-info-text">{{item.content | expression}}</div>
              </div>
              <div class="message-img"><img :src="item.user.portrait"></div>
            </div>
          </div>
        <!-- </cube-scroll> -->
      </div>
      <div class="message-send">
        <div class="message-send-input"><input type="text" v-model="message"></div>
        <div class="message-send-img" @click="selectFile">
          <img src="../../assets/chatimg/img.svg">
          <input id="upFile" type="file" ref="upFile" @change="getFile" style="display:none;">
          <span>发图片</span>
        </div>
        <div class="message-send-submit" @click="messagebox">
          <img src="../../assets/chatimg/send.svg">
          <span>发送</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
var im
import { appkey } from '@/api/path.js'
export default {
  name: 'shopdetails',
  data() {
    return {
      appkey: appkey,
      speak: [],
      emojiList: [],
      token: localStorage.getItem('chatToken'),
      chatRoomId: '10010',
      message: '',
      id: '',
      cuId:  localStorage.getItem('cuId'),
      cuName:  localStorage.getItem('cuName'),
      portrait:  localStorage.getItem('portrait'),
      scrollY: 0,
    }
  },
  created(){
    this.chatRoomId = this.$route.query.roomid
    this.client()
  },
  methods: {
    // 连接融云聊天室
    client() {
      let that = this
      im = RongIMLib.init({
        appkey: that.appkey
      });

      var user = {
        token: that.token
      };
      im.connect(user).then(function(user) {
        console.log('链接成功, 链接用户 id 为: ', user.id);
        that.chatRoom()
      }).catch(function(error) {
        console.log('链接失败: ', error.code, error.msg);
      });

      var conversationList = []; // 当前已存在的会话列表
      im.watch({
        conversation: function(event){
          var updatedConversationList = event.updatedConversationList; // 更新的会话列表
          console.log('更新会话汇总:', updatedConversationList);
          console.log('最新会话列表:', im.Conversation.merge({
            conversationList: conversationList,
            updatedConversationList: updatedConversationList
          }));
        },
        message: function(event){
          var message = event.message;
          console.log('收到新消息', message);
          if (message.content.content && message.content.user) {
            // that.speak = [];
            that.speak.push(message.content)
            that.scrollBttom()
          }
          console.log('收到消息', that.speak);
          // that.speak = message
        },
        status: function(event){
          var status = event.status;
          switch (status) {
            case RongIMLib.CONNECTION_STATUS.CONNECTED:
              console.log('链接成功');
              break;
            case RongIMLib.CONNECTION_STATUS.CONNECTING:
              console.log('正在连接中');
              break;
            case RongIMLib.CONNECTION_STATUS.DISCONNECTED:
              console.log('已主动断开连接');
              break;
            case RongIMLib.CONNECTION_STATUS.NETWORK_UNAVAILABLE:
              console.log('网络不可用'); // SDK 内部会自动进行重连
              break;
            case RongIMLib.CONNECTION_STATUS.SOCKET_ERROR:
              console.log('Socket 链接错误'); // SDK 内部会自动进行重连
              break;
            case RongIMLib.CONNECTION_STATUS.KICKED_OFFLINE_BY_OTHER_CLIENT:
              console.log('其他设备登录, 本端被踢'); // 己端被踢, 不可进行重连. 否则会造成多端循环互踢
              break;
            case RongIMLib.CONNECTION_STATUS.BLOCKED:
              console.log('链接断开, 用户已被封禁');
              break;
            default:
              console.log('链接状态变化为:', status);
              break;
          }
        }
      });
      
    },
    // 加入聊天室
    chatRoom() {
      let that = this
      var chatRoomId = this.chatRoomId;
      var count = 10;
      var chatRoom = im.ChatRoom.get({
        id: chatRoomId,
        count: count
      });
      chatRoom.join({
        count: 20 // 进入后, 自动拉取 20 条聊天室最新消息
      }).then(function() {
        console.log('加入聊天室成功');
      });
    },
    // 发送消息
    messagebox() {
      let that = this
      var chatRoom = im.ChatRoom.get({
        id: that.chatRoomId
      });
      chatRoom.send({
        messageType: RongIMLib.MESSAGE_TYPE.TEXT, // 'RC:TxtMsg'
        content: {
          content: that.message, // 发送文本内容
          user: {
            name: that.cuName,
            portrait: that.portrait
          },
        }
      }).then(function(message){
        that.speak.push(message.content)
        that.message = ''
        that.scrollBttom()
        console.log('发送文字消息成功', message);
      });
    },
    // 选择文件
    selectFile(){
      this.$refs.upFile.click()
    },
    getFile(e){
      let that = this;
      var _file = e.target.files[0];
      var fileType;
      if(_file.type.split('/')[0] == 'image'){
        fileType = RongIMLib.FileType.IMAGE; 
      }else{
        fileType = RongIMLib.FileType.FILE; 
      }
      var config = {
        domain: 'https://upload.qiniup.com',
        fileType: fileType,
        getToken: function(callback) {
          RongIMClient.getInstance().getFileToken(fileType, {
            onSuccess: function(data){
              callback(data.token);
            },
            onError: function(){
              console.error('get file token error', error);
            }
          });
        }
      };
      var uploadCallbacks = {
        onProgress: function(loaded, total) {
          var percent = Math.floor(loaded / total * 100);
          console.log('已上传: ', percent);
        },
        onCompleted: function(data) {
          // 上传完成, 调用 getFileUrl 获取文件下载 url
          console.log('上传成功: ', data);
          let fileInfo  = data
          RongIMClient.getInstance().getFileUrl(fileType, data.filename, data.name, {
            onSuccess: function(data) {
              console.log('文件 url 为: ', data.downloadUrl);
              var conversationType = RongIMLib.ConversationType.PRIVATE;
              // var targetId = targetId;  // 目标 Id
              var msg = null;
              if(_file.type.split('/')[0] == 'image'){
                msg = new RongIMLib.ImageMessage({
                  content: fileInfo.thumbnail,  // 压缩后的 base64 略缩图, 用来快速展示图片, 
                  imageUri: data.downloadUrl  // 上传到服务器的 url. 用来展示高清图片
                });
              }else{  
                msg = new RongIMLib.FileMessage({
                  name: fileInfo.name,
                  size: fileInfo.size,
                  type: 'file',
                  fileUrl: data.downloadUrl
                });
              }
              RongIMClient.getInstance().sendMessage(conversationType, targetId, msg, {
                onSuccess: function (message) {
                  console.log('发送图片、文件消息成功', message);
                  if(message.messageType == 'ImageMessage'){
                    that.imgList.push({
                      url:message.content.fileUrl, type:'1', content:'', user_id:message.senderUserId,
                      time:ConveTime(message.sentTime)
                    })
                  }
                  that.$set(that.msgList,that.msgList.length,message)
                  that.speak.push(message.content)
                  that.scrollBttom()
                },
                onError: function (errorCode) {
                  console.log('发送图片、文件消息失败', errorCode);
                }
              });
            },
            onError: function(error) {
              console.log('get file url error', error);
            }
          })
        },
        onError: function(error) {
            console.error('上传失败', error);
        }
      };
      if(_file.type.split('/')[0] == 'image'){
        UploadClient.initImage(config, function(uploadFile) { 
          uploadFile.upload(_file, uploadCallbacks);
        });
      }else{
        UploadClient.initFile(config, function(uploadFile) { 
          uploadFile.upload(_file, uploadCallbacks);
        });
      }
    },
    // 滚动到底部
    scrollBttom(){
      this.$nextTick(() => {
        let container = this.$el.querySelector(".message-list");
        container.scrollTop = container.scrollHeight;
      });
    },

  }
}
</script>

<style lang="scss">
  .home {
    padding: 60px 0;
    background: linear-gradient(180deg,#95a0ad, #7b8591 99%);
  }
  .message {
    width: 780px;
    margin: 0 auto;
    background: #f4f4f4;
    // height: 2.7rem;
    .message-title {
      height: 95px;
      line-height: 95px;
      background: linear-gradient(134deg,#225aeb -1%, #037af5 102%);
      font-size: 26px;
      font-family: PingFangSC, PingFangSC-Bold;
      font-weight: 700;
      text-align: center;
      color: #ffffff;
    }
    .message-list {
      width: 780px;
      height: 810px;
      overflow: hidden;
      overflow-y: auto;
      background: #f7f7f7;
      .message-left {
        display: flex;
        padding: 0.1rem;
        font-size: 0;
        .message-img {
          flex: 0 0 0.3rem;
          img {
            width: 0.3rem;
            height: 0.3rem;
            border-radius: 50%;
            vertical-align: top;
          }
        }
        .message-info {
          flex: 1;
          margin-left: 0.05rem;
          text-align: left;
          font-size: 0;
          .message-info-name {
            // flex: 0 0 0.4rem;
            padding: 0.1rem 0.05rem;
            align-self: top;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
            text-align: left;
            // vertical-align: top;
            font-size: 0.12rem;
            color: #707070;
          }
          .message-info-text {
            display: inline-block;
            border-radius: 0.05rem;
            background: #fff;
            padding: 0.05rem 0.1rem;
            line-height: 0.15rem;
            text-align: left;
            align-self: center;
            font-size: 0.12rem;
            color: #252525;
          }
        }
      }
      .message-right {
        display: flex;
        padding: 0.1rem;
        font-size: 0;
        .message-img {
          flex: 0 0 0.3rem;
          img {
            width: 0.3rem;
            height: 0.3rem;
            border-radius: 50%;
            vertical-align: top;
          }
        }
        .message-info {
          flex: 1;
          margin-left: 0.05rem;
          text-align: right;
          font-size: 0;
          .message-info-name {
            // flex: 0 0 0.4rem;
            padding: 0.1rem 0.05rem;
            align-self: top;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
            text-align: right;
            // vertical-align: top;
            font-size: 0.12rem;
            color: #707070;
          }
          .message-info-text {
            display: inline-block;
            border-radius: 0.05rem;
            background: #fff;
            padding: 0.05rem 0.1rem;
            line-height: 0.15rem;
            text-align: left;
            align-self: center;
            font-size: 0.12rem;
            color: #252525;
          }
        }
      }
    }
    .message-send {
      display: flex;
      width: 780px;
      .message-send-input {
        flex: 1;
        height: 70px;
        font-size: 0;
        input {
          width: 100%;
          height: 70px;
          font-size: 30px;
          text-indent: 10px;
        }
      }
      .message-send-img {
        flex: 0 0 150px;
        height: 70px;
        line-height: 70px;
        text-align: center;
        background: #f5a623;
        font-size: 0;
        img {
          width: 24px;
          height: 24px;
          vertical-align: middle;
        }
        span {
          margin-left: 10px;
          font-size: 20px;
          font-family: PingFangSC, PingFangSC-Bold;
          font-weight: 700;
          color: #ffffff;
          vertical-align: middle;
        }
      }
      .message-send-submit {
        flex: 0 0 180px;
        height: 70px;
        line-height: 70px;
        text-align: center;
        background: #007aff;
        font-size: 0;
        img {
          width: 24px;
          height: 24px;
          vertical-align: middle;
        }
        span {
          margin-left: 10px;
          font-size: 20px;
          font-family: PingFangSC, PingFangSC-Bold;
          font-weight: 700;
          color: #ffffff;
          vertical-align: middle;
        }
      }
    }
  }
</style>